"use strict";
/// <reference types="cookiebot-sdk" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAnalyticsConsent = exports.ANALYTICS_COOKIE_NAME = void 0;
exports.ANALYTICS_COOKIE_NAME = 'CookieConsent';
const getAnalyticsConsent = () => {
    if (!window.Cookiebot || !window.Cookiebot.hasResponse) {
        return null;
    }
    return {
        marketing: window.Cookiebot.consent.marketing,
        necessary: window.Cookiebot.consent.necessary,
        statistics: window.Cookiebot.consent.statistics,
        preferences: window.Cookiebot.consent.preferences,
    };
};
exports.getAnalyticsConsent = getAnalyticsConsent;
